// wp-icons — Status & Indicators (13)
import { createWpIcon } from './createIcon.js';

export const CheckCircle = createWpIcon('CheckCircle', [
  ['path', { d: 'M21.801 10A10 10 0 1 1 17 3.335', key: 'a' }],
  ['path', { d: 'm9 11 3 3L22 4', key: 'b' }],
]);
export const CheckCircle2 = createWpIcon('CheckCircle2', [
  ['circle', { cx: 12, cy: 12, r: 10, key: 'a' }],
  ['path', { d: 'm9 12 2 2 4-4', key: 'b' }],
]);
export const XCircle = createWpIcon('XCircle', [
  ['circle', { cx: 12, cy: 12, r: 10, key: 'a' }],
  ['path', { d: 'm15 9-6 6', key: 'b' }],
  ['path', { d: 'm9 9 6 6', key: 'c' }],
]);
export const AlertCircle = createWpIcon('AlertCircle', [
  ['circle', { cx: 12, cy: 12, r: 10, key: 'a' }],
  ['line', { x1: 12, x2: 12, y1: 8, y2: 12, key: 'b' }],
  ['line', { x1: 12, x2: 12.01, y1: 16, y2: 16, key: 'c' }],
]);
export const AlertTriangle = createWpIcon('AlertTriangle', [
  ['path', { d: 'm21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z', key: 'a' }],
  ['path', { d: 'M12 9v4', key: 'b' }],
  ['path', { d: 'M12 17h.01', key: 'c' }],
]);
export const Info = createWpIcon('Info', [
  ['circle', { cx: 12, cy: 12, r: 10, key: 'a' }],
  ['path', { d: 'M12 16v-4', key: 'b' }],
  ['path', { d: 'M12 8h.01', key: 'c' }],
]);
export const HelpCircle = createWpIcon('HelpCircle', [
  ['circle', { cx: 12, cy: 12, r: 10, key: 'a' }],
  ['path', { d: 'M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3', key: 'b' }],
  ['path', { d: 'M12 17h.01', key: 'c' }],
]);
export const MinusCircle = createWpIcon('MinusCircle', [
  ['circle', { cx: 12, cy: 12, r: 10, key: 'a' }],
  ['path', { d: 'M8 12h8', key: 'b' }],
]);
export const MinusSquare = createWpIcon('MinusSquare', [
  ['rect', { width: 18, height: 18, x: 3, y: 3, rx: 2, ry: 2, key: 'a' }],
  ['path', { d: 'M8 12h8', key: 'b' }],
]);
export const Circle = createWpIcon('Circle', [['circle', { cx: 12, cy: 12, r: 10, key: 'a' }]]);
export const CircleDashed = createWpIcon('CircleDashed', [
  ['path', { d: 'M10.1 2.182a10 10 0 0 1 3.8 0', key: 'a' }],
  ['path', { d: 'M13.9 21.818a10 10 0 0 1-3.8 0', key: 'b' }],
  ['path', { d: 'M17.609 3.721a10 10 0 0 1 2.69 2.7', key: 'c' }],
  ['path', { d: 'M2.182 13.9a10 10 0 0 1 0-3.8', key: 'd' }],
  ['path', { d: 'M20.279 17.609a10 10 0 0 1-2.7 2.69', key: 'e' }],
  ['path', { d: 'M21.818 10.1a10 10 0 0 1 0 3.8', key: 'f' }],
  ['path', { d: 'M3.721 6.391a10 10 0 0 1 2.7-2.69', key: 'g' }],
  ['path', { d: 'M6.391 20.279a10 10 0 0 1-2.69-2.7', key: 'h' }],
]);
export const Square = createWpIcon('Square', [['rect', { width: 18, height: 18, x: 3, y: 3, rx: 2, key: 'a' }]]);
export const CheckSquare = createWpIcon('CheckSquare', [
  ['path', { d: 'm9 11 3 3L22 4', key: 'a' }],
  ['path', { d: 'M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11', key: 'b' }],
]);
export const Ban = createWpIcon('Ban', [
  ['circle', { cx: 12, cy: 12, r: 10, key: 'a' }],
  ['path', { d: 'm4.9 4.9 14.2 14.2', key: 'b' }],
]);
export const Flag = createWpIcon('Flag', [
  ['path', { d: 'M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z', key: 'a' }],
  ['line', { x1: 4, x2: 4, y1: 22, y2: 15, key: 'b' }],
]);
